export const DEV = 'dev'
export const CLIENT_LAYOUT = 'client-facing'
export const OSR_LAYOUT = 'osr-facing'
export const ADMIN = 'administrative'

export const DEFAULT_CLIENT_PAGE = '/dashboard'
export const DEFAULT_ADMIN_PAGE = '/staff/dashboard'
